import { useMutation } from '@apollo/client';
import { useRouter, useShowToast } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  AccountDeleteAccountMutation,
  AccountDeleteAccountMutationVariables,
} from '@gql/graphql';
import type { MtDeleteAccountModalFormValues } from '@presentation/components';
import { useFormik } from 'formik';
import { useCurrentAccount } from '..';

export const ACCOUNT_DELETE_ACCOUNT = graphql(`
  mutation AccountDeleteAccount($feedback: String!) {
    deleteAccount(feedback: $feedback)
  }
`);

export const useDeleteAccount = () => {
  const { showToast } = useShowToast();
  const { translate, navigateToRoute } = useRouter();
  const { currentAccountLogout } = useCurrentAccount();

  const deleteModalForm = useFormik<MtDeleteAccountModalFormValues>({
    initialValues: {
      feedback: '',
    },
    onSubmit: async (values) => {
      await deleteMutation({
        variables: {
          feedback: values.feedback,
        },
      });
      currentAccountLogout();
      showToast(translate('common.toasts.accountDeleteSuccess'), {
        type: 'success',
      });
      navigateToRoute('homeLanding');
    },
  });

  const [deleteMutation, { error, loading }] = useMutation<
    AccountDeleteAccountMutation,
    AccountDeleteAccountMutationVariables
  >(ACCOUNT_DELETE_ACCOUNT);

  return {
    deleteModalForm,
    deleteAccountLoading: loading,
    deleteAccountError: error,
  };
};
